<template>
  <dialog-edit v-if="dialog" :value="dialog" @input="dialog = !true" :maxWidth="'1200px'">
    <template v-slot:title> Новый проект {{ id }} </template>
    <v-card class="text-left" style1="height: 100%; position: relative " style="position: absolute; top: 0; left: 0; right: 0; bottom: 0">
      <v-card flat style="position: absolute; bottom: 0; top: 0; left: 0; overflow: auto; width: 220px; border-right: 1px solid #ddd">
        <v-list dense>
          <v-list-item-group v-model="selected" color="primary" mandatory>
            <v-list-item v-for="item in items" :key="item.name" link :disabled="!item.enabled" @click="item.enabled && (step = item.name)">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon v-if="!item.enabled">
                <v-icon>fas fa-lock</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
      <v-card flat class="pa-6 overflow-auto" style="position: absolute; bottom: 0; top: 0; right: 0; left: 220px">
        <div v-if="step === 'start'">
          <h3 v-if="m.wizard.steps.start && m.wizard.steps.start.title" class="mb-4">{{ m.wizard.steps.start.title }}</h3>
          <template v-if="m.wizard.steps.start && m.wizard.steps.start.content">
            <p v-for="(t, i) in m.wizard.steps.start.content" :key="i" class="mb-2">{{ t }}</p>
          </template>

          <a-form-model v-model="data" :model="model" :values="data" :errors="errors" :config="{ dense: true, hideDetails: 'auto' }" @validate="validate($event)" />
          <portal to="v-wizard-action">
            <v-btn @click="onNext">Далее</v-btn>
          </portal>
        </div>

        <div v-else-if="step === 'client'">
          <Client :wizard="data.wizard_data" @save="onSave" @next="onNext" :mw="m.wizard.steps.client" />
        </div>

        <div v-else-if="step === 'object'">
          <Object :wizard="data.wizard_data" @save="onSave" @next="onNext" :mw="m.wizard.steps.object" />
        </div>
        <div v-else-if="step === 'services'">
          <Services :wizard="data.wizard_data" @save="onSave" @next="onNext" :mw="m.wizard.steps.services" />
        </div>
        <div v-else-if="step === 'questionnaire'">
          <Questionnaire :wizard="data.wizard_data" @save="onSave" @next="onNext" :mw="m.wizard.steps.questionnaire" />
        </div>
        <div v-else-if="step === 'estimate'">
          <Estimate :wizard="data.wizard_data" @save="onSave" @next="onNext" :mw="m.wizard.steps.estimate" />
        </div>
        <div v-else-if="step === 'contract'">
          <Contract :wizard="data.wizard_data" @save="onSave" @next="onNext" :mw="m.wizard.steps.contract" />
        </div>
        <div v-else-if="step === 'complete'">
          <Complete :wizard="data.wizard_data" @save="onSave" @next="onNext" :mw="m.wizard.steps.complete" />
        </div>
      </v-card>
    </v-card>
    <template v-slot:actions>
      <v-btn @click="$emit('input')">Закрыть</v-btn>
      <a-btn-delete v-if="id && getAccess('contract.wizard.delete')" @click="_remove()"></a-btn-delete>

      <v-spacer></v-spacer>
      <portal-target name="v-wizard-action" />
    </template>
  </dialog-edit>
</template>
<script>
import { getAccess, getForm, submitForm, genModel, removeEl } from "@/components/mixings";
import { template } from "lodash";
export default {
  components: {
    Client: () => import("./step/step-client"),
    Object: () => import("./step/step-object"),
    Services: () => import("./step/step-services"),
    Estimate: () => import("./step/step-estimate"),
    Contract: () => import("./step/step-contract"),
    Complete: () => import("./step/step-complete"),
    Questionnaire: () => import("./step/step-questionnaire"),
  },
  mixins: [getAccess, getForm, submitForm, genModel, removeEl],
  props: { value: { type: Boolean, default: false }, id: Number },
  data() {
    return {
      loaded: true,
      dialog: true,
      selected: 0,
      step: "",
      api: "/accounting/dir/contract/wizard",
      m: this.$store.getters["config/get"].models.contracts,
      model: [],
    };
  },
  computed: {
    wizard: {
      get() {
        return this.data?.wizard_data || {};
      },
    },
    estimateData() {
      return this.data?.wizard_data?.estimate || {};
    },
    clientData() {
      return this.data?.wizard_data?.client || {};
    },
    objectData() {
      return this.data?.wizard_data?.object || {};
    },
    serviceData() {
      return this.data?.wizard_data?.services || [];
    },
    items() {
      let res = [
        { title: "Начало", icon: "fas fa-play", name: "start", enabled: true },
        { title: "Клиент", icon: "fas fa-user", name: "client", enabled: this.data.id },
        { title: "Объект", icon: "fas fa-building", name: "object", enabled: this.wizard?.client?.id },
        { title: "Работы", icon: "fas fa-hammer", name: "services", enabled: this.wizard?.object?.id },
        { title: "Анкета", icon: "fas fa-hammer", name: "questionnaire", enabled: (this.wizard?.services?.services || []).length > 0 },
        { title: "КП", icon: "fas fa-file-invoice", name: "estimate", enabled: !!this.wizard?.questionnaire?.answers },
        {
          title: "Договор",
          icon: "fas fa-file-signature",
          name: "contract",
          enabled: (this.wizard?.services?.services || []).length > 0 && (this.wizard?.estimate?.id || this.wizard?.estimate?.skip),
        },
        { title: "Завершение", icon: "fas fa-flag", name: "complete", enabled: this.wizard?.contract?.template_id },
      ];
      return res;
    },
  },
  created() {
    this.loaded = false;
    this.updateData(this.id);
    if (!this.id) {
      this.loaded = true; ///  this.type = 1;
      //  this.data.status = 0;
    }
  },
  watch: {
    dialog(v) {
      if (!v) this.$emit("close");
    },
    value: {
      immediate: true,
      handler(v) {
        this.dialog = v;
      },
    },
  },
  methods: {
    async onSave(data, done) {
      console.log("parent onsave ", data);
      // делаем что-то
      const id = this.data.id;
      if (!id) return;
      if (!this.data?.wizard_data) {
        this.$set(this.data, "wizard_data", {});
      }
      const wizard_data = Object.assign({}, this.data.wizard_data);
      if (this.step == "client") {
        wizard_data.client = data;
        let response = await this.$axios.post(this.api, { id, wizard_data, side_2_client_id: data.id });
        let status = response.data.status == "ok";
        if (response.data.data) {
          Object.assign(this.data, response.data.data);
          this.$root.$emit("show-info", {
            text: "Проект обновлен",
          });
        }
        done({ ok: true, message: "Сохранено!" });
        return;
      }
      if (this.step == "object") {
        wizard_data.object = data;
        let response = await this.$axios.post(this.api, { id, wizard_data });
        let status = response.data.status == "ok";
        if (response.data.data) {
          Object.assign(this.data, response.data.data);
          this.$root.$emit("show-info", {
            text: "Проект обновлен",
          });
        }
        done({ ok: true, message: "Сохранено!" });
        return;
      }
      if (this.step == "questionnaire") {
        console.log("qqqq,data", data);
        wizard_data.questionnaire = data;
        let response = await this.$axios.post(this.api, { id, wizard_data });
        let status = response.data.status == "ok";
        if (response.data.data) {
          Object.assign(this.data, response.data.data);
          this.$root.$emit("show-info", {
            text: "Проект обновлен",
          });
        }
        done({ ok: true, message: "Сохранено!" });
        return;
      }
      if (this.step == "services") {
        wizard_data["services"] = data;
        let response = await this.$axios.post(this.api, { id, wizard_data });
        let status = response.data.status == "ok";
        if (response.data.data) {
          Object.assign(this.data, response.data.data);
          this.$root.$emit("show-info", {
            text: "Проект обновлен",
          });
          console.log("ddd", this.data);
        }
        done({ ok: true, message: "Сохранено!" });
        return;
      }
      if (this.step == "estimate") {
        console.log("est", data);
        wizard_data.estimate = data;
        let response = await this.$axios.post(this.api, { id, wizard_data });
        let status = response.data.status == "ok";
        if (response.data.data) {
          Object.assign(this.data, response.data.data);
          this.$root.$emit("show-info", {
            text: "Проект обновлен",
          });
        }
        done({ ok: true, message: "Сохранено!" });
        return;
      }
      if (this.step == "contract") {
        console.log("contract", data);
        wizard_data.contract = data;
        let response = await this.$axios.post(this.api, { id, wizard_data });
        let status = response.data.status == "ok";
        if (response.data.data) {
          Object.assign(this.data, response.data.data);
          this.$root.$emit("show-info", {
            text: "Проект обновлен",
          });
        }
        done({ ok: true, message: "Сохранено!" });
        return;
      }
      if (this.step == "complete") {
        data.id = this.data.id;
        console.log("complete", data);
        let response = await this.$axios.post(this.api, data);
        let status = response.data.status == "ok";
        if (status && response.data.data) {
          Object.assign(this.data, response.data.data);
          this.$root.$emit("show-info", {
            text: "Проект Завершен",
          });
          done({ ok: true, message: "Сохранено!" });
          this.$router.push({ name: "contracts_view", params: { id: this.data.id } });
        }
      }
      done({ ok: false, message: "еррор!" });
    },
    async onNext(e = 1) {
      if (e == -1) {
        this.selected--;

        this.step = this.items[this.selected].name;
        return;
      }
      if (!this.step) {
        const enabledItems = this.items.filter((i) => i.enabled);
        const last = enabledItems[enabledItems.length - 1];
        this.step = last.name;
        this.selected = this.items.findIndex((i) => i.name == this.step);
        return;
      }
      if (this.step == "start") {
        if (this.data.id && this.isChanged) {
          const confirmed = await this.$root.$confirm({
            title: "Вопрос",
            message: ["Данные были изменены.", "Вы хотите их сохранить?"],
            okButton: "Да",
            cancelButton: "Нет",
          });
          if (confirmed) {
            if (await this.submit()) {
            } else {
              return;
            }
          } else {
            this.updateData(this.id);
          }
        } else if (!this.data.id) {
          if (await this.submit()) {
          } else {
            return;
          }
        }
      }
      this.$nextTick(() => {
        if (this.items[this.selected + 1].enabled) {
          this.selected++;

          this.step = this.items[this.selected].name;
        } else {
          this.$root.$emit("show-info", {
            text: "Следующий шаг еще не доступен",
            type: "error",
          });
        }
      });
    },
    afterFetchData() {
      this.getModel();
      this.onNext();
    },
    async _remove() {
      const confirmed = await this.$root.$confirm({
        title: "Удаление",
        message: ["Вы действительно хотите удалить этот проект?", "Созданные клиент, объект и смета удалены НЕ будут."],
        okButton: "Да",
        cancelButton: "Нет",
      });
      if (confirmed) {
        this.remove(this.api, this.id);
      } else {
        return;
      }
    },
    afterRemove(data) {
      this.$emit("input");
      this.dialog = !true;
    },
    getModel() {
      let model = this.getModelList(this.m, "formWizard");
      this.fillFormFromModel(model);
      this.model = model;
    },
  },
};
</script>
<style scoped></style>
